import { useQuery } from '@tanstack/react-query';
import { dashboardApi, type DashboardData } from '../api/services/dashboard';

export function useDashboard() {
  return useQuery<DashboardData>({
    queryKey: ['admin', 'dashboard'],
    queryFn: () => dashboardApi.get(),
  });
}
